export { PassengerInfoModal } from './PassengerInfoModal'


// WEBPACK FOOTER //
// ./src/components/EnhancedModal/components/PassengerInfoModal/index.js